/**
 * Responsável por adicionar os markers de Stops no mapa.
 * Created by adalto on 5/7/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.Signatures = (() => {

    function SignatureLayer () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'signature';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.Signatures';

        let instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = (element) => {

            const _element = element.target;
            const status = !!_element.checked;

            if(instanceToDataClass) {
                if(status) {
                    instanceToDataClass.getSignaturesAndDrawOnMap();
                } else {
                    instanceToDataClass.removeSignaturesFromMap();
                }
            }

            this.fireEvent("afterClickOnCheckBox");
        };

    }

    return SignatureLayer;


})();
